<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap justify-start>
				<!-- <v-flex xs12>
					<app-card>
						<v-card-title>
							<h1>Hello Admin !</h1>
						</v-card-title>
					</app-card>
                </v-flex> -->
				<restore-database v-if="is_local" @reloadCollection="reload_collection = !reload_collection" colClasses="xs12 md6"></restore-database>
				<clear-database v-if="is_local" :reload_collection="reload_collection" colClasses="xs12 md6"></clear-database>
				<app-card colClasses="xs12 md6">
					<v-card-title>
						<h3>Chợ tốt - chotot.com</h3>
					</v-card-title>
					<chotot></chotot>
				</app-card>
				<app-card colClasses="xs12 md6">
					<v-card-title>
						<h3>Tạo phòng mới</h3>
					</v-card-title>
					<v-btn block @click="showFormTaoPhong = !showFormTaoPhong" color="primary">
						Tạo Phòng Mới
					</v-btn>
					<v-dialog v-model="showFormTaoPhong" max-width="80%">
						<tao-phong></tao-phong>
					</v-dialog>
				</app-card>
				<v-flex xs12 md6>
                    <init-data></init-data>
                </v-flex>
            </v-layout>
        </v-container>
	</div>
</template>
<script>
import InitData from './InitData'
import TaoPhong from '../QuanLyPhong/TaoPhong'
import Chotot from './Chotot'
import ClearDatabase from './ClearDatabase'
import RestoreDatabase from './RestoreDatabase'

export default {
    name: "Admin",
    components: {
		InitData,
		TaoPhong,
		Chotot,
		ClearDatabase,
		RestoreDatabase
    },
	data() {
		return {
			showFormTaoPhong: false,
			reload_collection: false,
		};
	},
	computed: {
		is_local(){
			return location.host.includes('localhost') || location.host.includes('127.0.0.1')
		}
	}
};
</script>